'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t;

import styled from 'styled-components';
import Features from 'self-service-api/constants/Features';
import FeatureTile from './FeatureTile';
import { getGAClassName } from 'pricing-pages-lib/utils/publicPageUrls';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ProductFeaturesMap from 'self-service-api/constants/ProductFeaturesMap';
import breakpoint from '../../utils/responsiveBreakpoints';
import { MARKETING, OPERATIONS, SALES, SERVICE, CMS } from 'self-service-api/constants/ProductLines';
import { FREE } from 'self-service-api/constants/ProductLevels';
const FeaturesSectionContainer = styled.div.withConfig({
  displayName: "FeaturesSection__FeaturesSectionContainer",
  componentId: "sc-1y1u0lh-0"
})(["width:100%;max-width:1300px;padding:0 20px;z-index:2;display:flex;flex-direction:column;"]);
const FeatureRow = styled.div.withConfig({
  displayName: "FeaturesSection__FeatureRow",
  componentId: "sc-1y1u0lh-1"
})(["display:flex;justify-content:center;", ""], breakpoint.tabletPortrait(_t || (_t = _`
    flex-direction: column
  `)));

const NewFeaturesSection = () => {
  // Removing the free feature here since it's a little redundant
  // on the free tools page that has a free CRM card
  const removeFreeFeature = features => {
    features = Object.assign({}, features);
    delete features[Features.ALL_CRM_FEATURES];
    return features;
  };

  return /*#__PURE__*/_jsx(FeaturesSectionContainer, {
    children: /*#__PURE__*/_jsxs(FeatureRow, {
      children: [/*#__PURE__*/_jsx(FeatureTile, {
        modalViewClassName: getGAClassName('crm-pricing-marketingfeatures'),
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.crm.freeMarketingTools"
        }),
        features: removeFreeFeature(ProductFeaturesMap[MARKETING][FREE]),
        productLine: MARKETING
      }), /*#__PURE__*/_jsx(FeatureTile, {
        modalViewClassName: getGAClassName('crm-pricing-salesfeatures'),
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.crm.freeSalesCRMTools"
        }),
        features: removeFreeFeature(ProductFeaturesMap[SALES][FREE]),
        productLine: SALES
      }), /*#__PURE__*/_jsx(FeatureTile, {
        modalViewClassName: getGAClassName('crm-pricing-servicefeatures'),
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.crm.freeServiceTools"
        }),
        features: removeFreeFeature(ProductFeaturesMap[SERVICE][FREE]),
        productLine: SERVICE
      }), /*#__PURE__*/_jsx(FeatureTile, {
        modalViewClassName: getGAClassName('crm-pricing-cmsfeatures'),
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.crm.freeCMSTools"
        }),
        features: removeFreeFeature(ProductFeaturesMap[CMS][FREE]),
        productLine: CMS
      }), /*#__PURE__*/_jsx(FeatureTile, {
        modalViewClassName: getGAClassName('crm-pricing-operationsfeatures'),
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.crm.freeOperationsTools"
        }),
        features: removeFreeFeature(ProductFeaturesMap[OPERATIONS][FREE]),
        productLine: OPERATIONS
      })]
    })
  });
};

export default NewFeaturesSection;